<template>
  <component :is="currentPage" />
</template>

<script>
import Index2Desktop from './index2'
import Index2Mobile from './index2Mobile'

export default {
  name: 'Index2Device',
  components: { Index2Desktop, Index2Mobile },
  data() {
    return { mobile: false }
  },
  computed: {
    currentPage() {
      return this.mobile ? 'Index2Mobile' : 'Index2Desktop'
    }
  },
  created() {
    this.detectDevice()
    window.addEventListener('resize', this.detectDevice)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.detectDevice)
  },
  methods: {
    detectDevice() {
      const forceDesktop = this.$route && String(this.$route.query.desktop || '') === '1'
      this.mobile = !forceDesktop && window.matchMedia('(max-width: 768px)').matches
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/index2Device.vue